import { change } from 'redux-form';
import  showToaster  from "../../helpers/toastrMessgaes/showToaster";
import { getOrderAction } from '../../actions/order/getOrderAction';
async function submit(values, dispatch) {
    try {
        if (!values?.promoId) {
            showToaster({ messageId: 'invalidPromoCode', toasterType: 'error' });
            return false;
        }
        if (values?.promoId) {
            dispatch(change("PromoCodeForm", 'validPromoCode', values?.promoCode));
            dispatch(getOrderAction({ promoId: values?.promoId }));
        }

    } catch (error) {
        return false;
    }
}

export default submit;